import * as yup from 'yup';
import { IEmbed } from '../../../pages/admin/embeds/embedsV2/interface';

export const internalUserSchema = yup.object().shape({
  productName: yup.string().required('Product Name is required'),
  productDescription: yup.string().required('Product Description is required'),

  brand_id: yup.string(),
  brand_name: yup.string().required('Brand Name is required'),
  brand_description: yup.string(),

  rmn_ids: yup.array().of(yup.number()),
});

export const brandUserSchema = yup.object().shape({
  productName: yup.string().required('Product Name is required'),
  productDescription: yup.string().required('Product Description is required'),
});

export interface ISchemaValues {
  productName: string;
  url?: string;
  productDescription: string;
  brand_id?: string;
  brand_name?: string;
  brand_description?: string;
  rmn_ids?: number[];
  product_category_ids?: number[];
  // Returns estimate (PDP Autopilot's reduce-returns metric): kept as
  // strings in the form, sent as integers or null.
  estimated_annual_units?: string;
  estimated_annual_returns?: string;
  /** TDC-1722: legal/claims copy; every brief on this product snapshots it. */
  disclaimers?: string;
}

export const initValues = {
  productName: '',
  url: '',
  productDescription: '',
  brand_name: '',
  brand_description: '',
  rmn_ids: [],
  product_category_ids: [] as number[],
  estimated_annual_units: '',
  estimated_annual_returns: '',
  disclaimers: '',
};

export interface ImageProps {
  source: string;
  error?: string;
  file?: any;
  extension?: string;
}

export interface IProduct {
  title?: string;
  url?: string;
  image?: string;
  description?: string;
  short_description?: string;
  desireid?: number | string;
  product_categories?: Array<{
    id: number;
    name?: string;
    parent_id?: number | null;
  }>;
  brands?: Array<{
    rmn: boolean;
    id: number;
    name?: string;
  }>;
  productVideos?: Array<{
    id: number;
    title: string;
    description: string;
    image: string;
    video: string;
    embeds?: IEmbed[];
  }>;
  pdp_url_count?: number;
  placed_count?: number;
  estimated_annual_units?: number | null;
  estimated_annual_returns?: number | null;
  disclaimers?: string | null;
}

export interface INewBrand {
  id?: number;
  name?: string;
  description?: string;
  image?: {
    file?: any;
    extension?: string;
  };
}
